export const checkError = (error) => {
  // Case when the API call does not resolve (canceled, etc.), so Axios don't receive a "response" property in Error object
  if(error.message  && (error.message === 'Network Error' || error.message.includes('timeout'))) {
    return "Error de conexión a Internet";
  }
  if(error.response && error.response.status > 500)
    return error.message;
  else
    return error.response.data.msg;  
}